import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MultiPaymentActionsComponent } from './multi-payment-actions.component';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';


@NgModule({
    declarations: [MultiPaymentActionsComponent],
    imports: [
        SharedModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        LFDropdownModule,
    ],
    exports: [MultiPaymentActionsComponent],
})
export class MultiPaymentActionsModule
{
}
